<template>
  <v-data-table :headers="colunas" :items="esclarecimentosImpugnacoes"
                :total-items="esclarecimentosImpugnacoes.length"
                :loading="false" hide-actions
                no-data-text="Não há esclarecimentos disponíveis"
                class="az-table-list px-4 pt-2">
    <template slot="items" slot-scope="props">
      <tr>
        <td>
          {{props.item.dataCadastro | az-date('DD/MM/YYYY HH:mm')}}
        </td>
        <td>
          <span v-if="props.item.fornecedor && props.item.fornecedor.razaoSocial">
            {{props.item.fornecedor.razaoSocial}}
          </span>
          <span v-else>
            {{ props.item.nomeRazaoSocial || '-'}}
          </span>
        </td>
        <td>
          {{ props.item.assunto || '-'}}
        </td>
        <td>
          {{ props.item.arquivoUri ? 'Sim' : 'Não' }}
        </td>
        <td v-if="props.item.situacao">
          {{ props.item.situacao | azEnum(situacoesEsclarecimentoImpugnacao)}}
        </td>
        <td v-else>-</td>
        <td style="text-align: center;width: 100%">
          <v-icon @click="$emit('visualizar', props.item)">search</v-icon>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
import {situacoesEsclarecimentoImpugnacao} from '@/core/constants'

export default{
    name: 'EsclarecimentoImpugnacaoTabela',
    props:{
        esclarecimentosImpugnacoes:{
            type: Array,
            default: () => []
        },
        tipo:{
            type: String,
            default: 'ESCLARECIMENTO'
        }
    },
    data(){
        return{
            situacoesEsclarecimentoImpugnacao,
            colunas: [
                {
                    value: 'data',
                    text: 'Data',
                    align: 'left',
                    width: '12%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'empresa',
                    text: 'Empresa/Nome',
                    align: 'left',
                    width: '16%',
                    sortable: false,
                    class: 'primary--text'
                },
                ... this.tipo === 'IMPUGNACAO' ? [
                    {
                        value: 'assunto',
                        text: 'Assunto Impugnação',
                        align: 'left',
                        width: '42%',
                        sortable: false,
                        class: 'primary--text'
                    },
                ] : [
                    {
                        value: 'assunto',
                        text: 'Assunto Esclarecimento',
                        align: 'left',
                        width: '42%',
                        sortable: false,
                        class: 'primary--text'
                    },
                ],
                {
                    value: 'anexo',
                    text: 'Anexo',
                    align: 'left',
                    width: '6%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'situacao',
                    text: 'Situação',
                    align: 'left',
                    width: '14%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    sortable: false,
                    text: 'Ações',
                    width: '10%',
                    align: 'center',
                    class: 'primary--text'
                }
            ],
        }
    }
}

</script>